<template>
  <div class="molecule-testimonial-card">
    <p class="testimonial-quote">{{ quote }}</p>
    <div v-if="name || title" class="testimonial-author">
      <div class="author-avatar" :style="{ backgroundColor: avatarColor }">
        {{ firstLetter }}
      </div>
      <div class="author-info">
        <p class="author-name">{{ name }}</p>
        <p v-if="title" class="author-title">{{ title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestimonialCard",
  props: {
    quote: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    firstLetter() {
      return this.name ? this.name.charAt(0).toUpperCase() : "?";
    },
    avatarColor() {
      // Professional color palette with good contrast for white text
      const colors = [
        "#2563eb", // Deep Blue
        "#0891b2", // Teal
        "#7c3aed", // Purple
        "#059669", // Green
        "#ea580c", // Orange
        "#4f46e5", // Indigo
        "#e11d48", // Rose
        "#d97706", // Amber
        "#10b981", // Emerald
        "#0284c7", // Sky Blue
        "#8b5cf6", // Violet
        "#c026d3", // Fuchsia
      ];

      if (!this.name) return colors[0];

      // Get the first letter and convert to index (0-25 for A-Z)
      const firstChar = this.name.charAt(0).toUpperCase();
      const charCode = firstChar.charCodeAt(0);
      const index = charCode - 65; // A = 0, B = 1, etc.

      // Use modulo to cycle through colors
      return colors[Math.abs(index) % colors.length];
    },
  },
};
</script>

<style scoped>
.molecule-testimonial-card {
  border-radius: 18px;
  padding: 1rem;
  /* background-color: #f5f5f5; */
  border: 1px solid #f5f5f5;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
}

.testimonial-quote {
  font-size: 1rem;
  color: #000;
  text-align: left;
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
  flex: 1;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.author-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 600;
  flex-shrink: 0;
}

.author-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-start;
  justify-content: flex-start;
}

.author-name {
  font-size: 0.95rem;
  color: #000;
  font-weight: 600;
  margin: 0;
}

.author-title {
  font-size: 0.85rem;
  color: #666;
  margin: 0;
}

@media (max-width: 768px) {
  .molecule-testimonial-card {
    padding: 1rem;
  }

  .testimonial-quote {
    font-size: 0.95rem;
    margin-bottom: 1.25rem;
  }

  .author-avatar {
    width: 44px;
    height: 44px;
    font-size: 1.1rem;
  }

  .author-name {
    font-size: 0.9rem;
  }

  .author-title {
    font-size: 0.8rem;
  }
}
</style>
